import type { ProfileLink } from "../data/profile";
import type { OpenProfileOverlay } from "../overlays/profileOverlay";
import { AddRow, LinkRow, ProfileSection } from "../profilePrimitives";

export function DocumentsSection({
    documents,
    setOverlay,
}: {
    documents: ProfileLink[] | undefined;
    setOverlay: OpenProfileOverlay;
}) {
    if (!documents) return null;

    return (
        <ProfileSection title="Links and documents">
            {documents.map((link) => (
                <LinkRow
                    key={link.id}
                    link={link}
                    onEdit={() => setOverlay({ type: "link-form", link })}
                    onDelete={() => setOverlay({ type: "link-delete", link })}
                />
            ))}
            <AddRow label="Add" onClick={() => setOverlay({ type: "link-form" })} />
        </ProfileSection>
    );
}
